import React from 'react';
import { orderToCargoQuantities } from '../../../utils/data-mapping-utils';
import { Load } from '../../../types';

// children of HereMapMarker (DeviceLocationMarker) which calls renderToStaticMarkup on the children components
// needs access to useSelector in useWeights() to get the users weight preference.  calling renderToStaticMarkup
// on redux things causes a crash
export const LoadCargo2: React.FC<{load: Load, convertFromGramsDisplay: (g: number) => string}> = (props) => {
    const { load, convertFromGramsDisplay } = props;
    const cargoQuantities = orderToCargoQuantities(load, convertFromGramsDisplay);

    return (
        <LoadCargoInternal cargoQuantities={cargoQuantities} />
    );
};

const LoadCargoInternal: React.FC<{cargoQuantities: any}> = (props) => {
    const { cargoQuantities } = props;

    return (
        <div>
            {cargoQuantities.map(([cargo, quantity]) => {
                return (
                    <div key={cargo}>
                        {quantity ? `${quantity} - ${cargo}` : `${cargo}`}
                    </div>
                );
            })}
            {/* <SalmonellaMeter severity={load.metadata?.cargo?.salmonellaResult} /> */}
        </div>
    );
};
